import { ArrowPathIcon, Cog6ToothIcon, ShoppingCartIcon, ArrowLeftIcon, Bars3Icon } from '@heroicons/react/24/outline';
import React, { useEffect, useState } from 'react'
import LogoImg from "../../assets/img/logo.png";
import { useOperation, useTransaction } from '../../store';
import { useContextState } from "../../context/Context";
import DatePicker, { DateObject } from "react-multi-date-picker";
import Sidebar from "../../components/utils/Sidebar";

const Transactions = () => {
  const { accountCTX } = useContextState();
  const { profile } = accountCTX

  const [displayDetails, setDisplayDetails] = useState<boolean>(false);
  const [operations, setOperations] = useState<any[]>([]);
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [displayMenu, setDisplayMenu] = useState<boolean>(false);
  const [displayDatePicker, setDisplayDatePicker] = useState<boolean>(false);
  const [year, setYear]  = useState<number | undefined>()
  const [month, setMonth]  = useState<number | undefined>()
  const [day, setDay]  = useState<number | undefined>()
  const [startDate, setStartDate]  = useState<string | undefined>()
  const [endDate, setEndDate]  = useState<string | undefined>()
  const [dateValue, setDateValue] = useState<any>();

  const { getSystemTransactions } = useTransaction();

  useEffect(() => {
    getLastOperations();
  }, []);

  const getLastOperations = async () => {
    const data = {
      start_date: startDate, 
      end_date: endDate, 
      year: year, 
      month: month, 
      day: day,
    }
    const apiCall = await getSystemTransactions(data);
    setOperations(apiCall);
  };

  const readDetails = async (id: string) => {
    const operation = operations.find((operation) => operation.id === id)
    setSelectedOperation(operation);
    setDisplayDetails(true);
  };

  useEffect(()=>{
    if (typeof(dateValue) !== 'undefined'){
      if (dateValue.length === 1){
        if (dateValue[0] instanceof DateObject) {
          const date = dateValue[0].toDate()
          setDay(date.getDate())
          setMonth(date.getMonth() + 1)
          setYear(date.getFullYear())
          setStartDate(undefined)
          setEndDate(undefined)
        }
      }
      else if (dateValue.length === 2){
        var start = dateValue[0].toDate()
        start = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate()
        var end = dateValue[1].toDate()
        end = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate()
        setStartDate(start)
        setEndDate(end)
        setDay(undefined)
        setMonth(undefined)
        setYear(undefined)
      }
    }
  }, [dateValue])


  return (
    <div className="h-full w-full overflow-hidden">
      {displayMenu && <Sidebar /> }
      {displayDetails && (
        <div
          className="absolute w-full h-screen bg-black bg-opacity-70  z-40 flex flex-col justify-end"
          onClick={() => setDisplayDetails(false)}
        >
          
          <div className="mx-auto bg-white bg-opacity-100 w-full rounded-t-2xl  py-16 z-50">
            <center>
              <h2 className="text-md text-green-500 mb-3"> {new Date(Date.parse(selectedOperation.created_at)).toLocaleString()} </h2>
              <p className="text-xs mt-3 text-primary uppercase"> {selectedOperation.transaction_type}</p>
              <p className="text-xs mt-3">Montant: {selectedOperation.amount} F CFA</p>
              {selectedOperation.sender_pseudo === profile.username && 
                <>
                  <p className="text-xs mt-3">Commission: {selectedOperation.commission} F CFA</p>
                  <p className="text-xs mt-3">Frais: {selectedOperation.fees} F CFA</p>
                  <p className="text-xs mt-3">Bonus utilisé {selectedOperation.bonus_used} F CFA</p>
                  <p className="text-xs mt-3">Bonus gagné {selectedOperation.bonus_earned} F CFA</p>
                </>
              }
            </center>
            
          </div>
        </div>
      ) }

      <div className="h-16 w-full  bg-white p-1 flex justify-between items-center">
        <img src={LogoImg} alt="logo" className="w-16 h-16 rounded-full" />
        {displayMenu ? (
          <button
            onClick={() => setDisplayMenu(false)}
            className="rounded-2xl w-12 h-12 flex justify-center items-center border aspect-square"
          >
            <ArrowLeftIcon className="w-8" />
          </button>
        ) : (
          <button
            onClick={() => setDisplayMenu(true)}
            className="rounded-2xl w-12 h-12 flex justify-center items-center border aspect-square"
          >
            <Bars3Icon className="w-8" />
          </button>
        )}
      </div>
      <div className="space-y-4 h-[calc(100%-4rem)] overflow-y-auto p-8">
        <h2 className="text-primary text-lg">Mes opérations</h2>
        <div className="w-full  space-y-4">
          
          {displayDatePicker ? 
            <>
              <div className='w-full bg-white shadow-sm p-2 rounded-xl '>
                <p className="text-xs text-gray-500">Veuillez sélectionner une date ou une plage de dates</p>
                <div className='w-full p-2 flex items-center '>
                  <DatePicker  
                    onChange={setDateValue} 
                    range 
                    className='rounded-2xl flex justify-center items-center border '
                  /> 
                  <button
                    onClick={() => getLastOperations()}
                    className="rounded-md w-12 bg-green-600 flex justify-center ml-6 items-center border "
                  >
                    Filtrer
                  </button>
                </div>
              </div>
            </>
            :
            <button
              onClick={() => setDisplayDatePicker(true)}
              className="rounded-2xl bg-green-300 flex justify-center items-center border p-2"
            >
              Filtrer les transactions
            </button>
          }
          {operations.map((operation:any, idx:any) => (
            <div
              key={idx}
              onClick={() => readDetails(operation.id)}
              className="w-full bg-white shadow-sm p-2 flex items-center justify-between rounded-xl gap-2"
            >
              <div className="p-2 flex gap-2 items-center">
                <ArrowPathIcon className="w-8 h-8 mx-auto text-primary" />
                <div>
                <h3 className="text-xs text-primary uppercase">
                  {operation.transaction_type}{" "}
                      {operation.receiver_pseudo === profile.username ? "de" : "à"}:{" "}
                  </h3>
                  <p className="text-sm text-gray-400">
                  {operation.receiver_pseudo === profile.username? operation.sender_name: operation.receiver_name}
                  </p>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500">
                  {/* {operation.date} à {operation.time} */}
                  {new Date(Date.parse(operation.created_at)).toLocaleString()}
                </p>
                <span className="text-sm text-primary flex justify-end">
                  {+operation.amount} F CFA
                </span>
              </div>
            </div>
          ))}
          {/* <div className="w-full bg-white shadow-sm p-2 flex items-center justify-between rounded-xl gap-2">
            <div className="p-2 flex gap-2 items-center">
              <ShoppingCartIcon className="w-8 h-8 mx-auto text-secondary" />
              <div>
                <h3 className="text-xs text-secondary">Paiment</h3>
                <p className="text-sm text-gray-400">chez Opéra</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-xs text-gray-500">12/01/2023 à 8:00</p>
              <span className="text-sm text-secondary">3 500 F CFA</span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
);
}

export default Transactions